import { Fragment } from "react";

import {
  moneyFormater,
  dateFormater,
  currencyTag,
  reportTitle,
} from "../../../utilities/formaters";

const TaxReportsDisplay = ({ report, currency }) => {
  const title = reportTitle[currency];
  const unit = currencyTag[currency];

  return (
    <div className="row">
      <div className="col-md-6">
        {report.fetched ? (
          <div>
            <strong>{title}</strong> <br />
            Original Currency :{" "}
            <strong>
              {moneyFormater(report.data.AccountingAmountOriginalCurrency)} [
              {unit}]
            </strong>{" "}
            <br />
            Accounting Amount:{" "}
            <strong>
              {moneyFormater(report.data.AccountingAmountSek)} [SEK]
            </strong>{" "}
            <br />
            From: <strong>{dateFormater(report.data.From)}</strong> <br />
            To: <strong>{dateFormater(report.data.To)}</strong>
          </div>
        ) : (
          <Fragment />
        )}
      </div>
    </div>
  );
};

export default TaxReportsDisplay;
